import { generateRoute } from './route';

export const AppModuleName = '/';

export const AppRoutes = {
    moduleRoute: () => generateRoute([AppModuleName]),
    mainPage: () => generateRoute([AppModuleName]),
};
